export default {
  financeSalesInvoice: {
    title: {
      list: '销售发票查询',
      invoice: '发票信息',
      rate: '客户开票信息',
      accounting: '会计信息',
      row: '行信息',
      glodenRate: '金税发票信息',
    },
    column: {
      expenseTypeCode: '费用类型',
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      ledgerCode: '账套',
      invoiceSource: '1销售提单,2销售退货,3手写',
      invoiceCompanyCode: '公司代码',
      invoiceCompanyName: '公司名称',
      transactionTypeCode: '事务处理类型',
      invoiceNum: '单据编号',
      invoiceCreatePersonCode: '制单人',
      invoiceCreatePersonName: '制单人',
      invoiceCreateDate: '制单日期',
      partnerCode: '客户编码',
      partnerName: '客户名称',
      currency: '币种',
      currencyName: '币种名称',
      exchangeType: '汇率类型',
      exchangeRate: '汇率',
      exchangeDate: '汇率日期',
      belongDate: '归属日期',
      invoiceAmount: '开票申请总金额',
      excludedTaxAmount: '不含税金额',
      taxAmount: '税额',
      invoiceType: '发票类型',
      invoiceStatus: '单据状态',
      invoiceAccountedAmount: '本币总金额',
      excludedTaxAccountedAmount: '本币不含税金额',
      taxAccountedAmount: '本币税额',
      recoverableTaxAmount: '合计出口退税额',
      differenceAmount: '与合同差异金额合计',
      ladingDifferenceAmount: '与提单/退货单差异金额合计',
      mark: '备注',
      openBankCode: '开户银行',
      openBankName: '开户银行名称',
      bankAccount: '银行账号',
      creditCode: '统一社会信用代码',
      partnerAddress: '客户地址',
      goldenTaxType: '增值税发票类型',
      goldenTaxDate: '开票日期',
      partnerPhone: '联系方式',
      goldenTaxStatus: '金税发票单据状态',
      accountingStatus: '入账状态',
      accountedDate: '入账日期',
      journalVoucherNum: '凭证编号',
      reverseDate: '冲销入账日期',
      reverseVoucherNum: '冲销凭证编号',
      performancePeriod: '天数',
      issueType: '开票状态',
      ticketPoint: '票点',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      ledgerCode: '请输入账套',
      invoiceSource: '请输入1销售提单,2销售退货,3手写',
      invoiceCompanyCode: '请输入公司代码',
      invoiceCompanyName: '请输入公司名称',
      transactionTypeCode: '请输入事务处理类型(下拉)',
      invoiceNum: '请输入单据编号',
      invoiceCreatePersonCode: '请输入制单人',
      invoiceCreatePersonName: '请输入制单人名称',
      invoiceCreateDate: '请选择制单日期',
      partnerCode: '请输入客户编码',
      partnerName: '请输入客户名称',
      currency: '请输入币种',
      currencyName: '请输入币种名称',
      exchangeType: '请选择汇率类型',
      exchangeRate: '请输入汇率',
      exchangeDate: '请选择汇率日期',
      belongDate: '请选择归属日期',
      invoiceAmount: '请输入发票总金额',
      excludedTaxAmount: '请输入不含税金额',
      taxAmount: '请输入税额',
      invoiceType: '请选择发票类型',
      invoiceStatus: '请选择单据状态',
      invoiceAccountedAmount: '请输入本币总金额',
      excludedTaxAccountedAmount: '请输入本币不含税金额',
      taxAccountedAmount: '请输入本币税额',
      recoverableTaxAmount: '请输入出口退税额',
      differenceAmount: '请输入与合同差异金额合计',
      mark: '请输入备注',
      openBankCode: '请输入开户银行',
      openBankName: '请输入开户银行名称',
      bankAccount: '请输入银行账号',
      creditCode: '请输入统一社会信用代码',
      partnerAddress: '请输入客户地址',
      goldenTaxType: '请选择增值税发票类型',
      goldenTaxDate: '请选择开票日期',
      partnerPhone: '请输入联系方式',
      goldenTaxStatus: '请选择金税发票单据状态',
      accountingStatus: '请选择入账状态',
      accountedDate: '请选择入账日期',
      journalVoucherNum: '请输入凭证编号',
      reverseDate: '请选择冲销入账日期',
      reverseVoucherNum: '请输入冲销凭证编号',
      openBankCodePlaceholder: '请选择开户银行',
      bankAccountPlaceholder: '请选择银行账号',
      goldenTaxTypePlaceholder: '请选择增值税发票类型',
      partnerPhonePlaceholder: '请选择联系方式',
    },
  },
  financeSalesInvoiceDetail: {
    column: {
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      invoiceId: '销售发票ID',
      invoiceCode: '销售发票编号',
      invoiceDetailCode: '销售发票行编号',
      invoiceDepartmentCode: '发票明细部门编码',
      invoiceDepartmentName: '部门',
      contractNo: '合同号',
      contractDetailNo: '合同行项目号',
      ladingNo: '提单号/退换货单号',
      ladingDetailNo: '提单/退换货单行项目号',
      ladingUnitPrice: '提单/退货单价',
      productNo: '商品编码',
      productDesc: '商品描述',
      ladingQuantity: '提单数量',
      invoicedQuantity: '已开票数量',
      contractUnitPrice: '合同单价',
      invoiceQuantity: '本次开票数量',
      invoiceUnit: '单位',
      invoiceUnitPrice: '含税单价',
      taxCode: '税码',
      taxRate: '税率',
      invoiceAmount: '含税总金额',
      ladingAmount: '提单金额',
      invoicedAmount: '已开票金额',
      settlementApplyInvoiceAmount: '结算已开票金额',
      excludedTaxAmount: '不含税金额',
      taxAmount: '税额',
      invoiceAccountedAmount: '本币含税金额',
      excludedTaxAccountedAmount: '本币不含税金额',
      taxAccountedAmount: '本币税额',
      currency: '币种',
      exchangeRate: '汇率',
      differenceAmount: '与合同差异金额',
      ladingDifferenceAmount: '与提单/退货单差异金额',
      mark: '备注',
      recoverableTaxRate: '出口退税率',
      recoverableTaxAmount: '出口退税额',
      reverseFlag: '冲销标识',
      reversePaymentLinesId: '冲销行ID',
      invoiceDesc: '开票描述',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      invoiceId: '请输入销售发票ID',
      invoiceCode: '请输入销售发票编号',
      invoiceDetailCode: '请输入销售发票行编号',
      invoiceDepartmentCode: '请输入发票明细部门编码',
      invoiceDepartmentName: '请输入发票明细部门名称',
      contractNo: '请输入合同号',
      contractDetailNo: '请输入合同行项目号',
      ladingNo: '请输入提单号',
      ladingDetailNo: '请输入提单行项目号',
      productNo: '请输入商品编码',
      productDesc: '请输入商品描述',
      ladingQuantity: '请输入提单数量',
      invoicedQuantity: '请输入已开票数量',
      contractUnitPrice: '请输入合同单价',
      invoiceQuantity: '请输入本次开票数量',
      invoiceUnit: '请输入单位',
      invoiceUnitPrice: '请输入含税单价',
      taxCode: '请选择税码',
      taxRate: '请输入税率',
      invoiceAmount: '请输入总金额',
      ladingAmount: '请输入提单金额',
      invoicedAmount: '请输入已开票金额',
      excludedTaxAmount: '请输入不含税金额',
      taxAmount: '请输入税额',
      invoiceAccountedAmount: '请输入本币含税金额',
      excludedTaxAccountedAmount: '请输入本币不含税金额',
      taxAccountedAmount: '请输入本币税额',
      currency: '请输入币种',
      exchangeRate: '请输入汇率',
      differenceAmount: '请输入与合同差异金额',
      mark: '请输入备注',
      recoverableTaxRate: '请输入出口退税率',
      recoverableTaxAmount: '请输入出口退税额',
      reverseFlag: '请输入冲销标识',
      reversePaymentLinesId: '请输入冲销行ID',
    },
  },
  saleInvoice: {
    contractNoSearch: '销售合同',
    invoiceCompany: '公司',
    invoiceCompanyCode: '公司代码',
    invoiceCompanyName: '公司名称',
    transactionType: '事务处理类型',
    transactionTypeCode: '事务处理类型代码',
    transactionTypeName: '事务处理类型名称',
    tradeType: '贸易类型',
    revAccount: '收入科目',
    invAccount: '库存科目',
    costAccount: '成本科目',
    shipAccount: '发出商品科目',
    createDate: '创建日期',
    createDateStart: '创建日期起',
    createDateEnd: '创建日期止',
    createPersonName: '创建人',
    transactionTypeStatus: '状态',
    lastModifyDate: '最后更新日期',
    lastModifyPersonName: '最后更新人',
    invoiceNum: '单据编号',
    invoiceCreatePersonName: '制单人',
    invoiceCreateDate: '制单日期',
    invoiceCreateDateStart: '制单日期起',
    invoiceCreateDateEnd: '制单日期止',
    partnerCode: '客户编码',
    partnerName: '客户名称',
    currency: '币种',
    exchangeDate: '汇率日期',
    belongDate: '归属日期',
    invoiceAmount: '含税总金额',
    taxAmount: '税额',
    excludedTaxAmount: '不含税金额',
    invoiceType: '发票类型',
    invoiceAccountedAmount: '本币含税总金额',
    taxAccountedAmount: '本币税额',
    excludedTaxAccountedAmount: '本币不含税金额',
    invoiceStatus: '单据状态',
    recoverableTaxAmount: '出口退税额',
    differenceAmountTotal: '与合同差异金额合计',
    ladingDifferenceAmountTotal: '与提单/退货单差异金额合计',
    differenceAmount: '与合同差异金额',
    mark: '备注',
    openBankCode: '开户银行',
    bankAccount: '银行账号',
    creditCode: '统一社会信用代码',
    partnerAddress: '客户地址',
    goldenTaxType: '增值税发票类型',
    goldenTaxDate: '开票日期',
    goldenTaxDateStart: '开票日期起',
    goldenTaxDateEnd: '开票日期止',
    partnerPhone: '联系方式',
    goldenTaxStatus: '金税发票单据状态',
    accountingStatus: '入账状态',
    accountedDate: '入账日期',
    accountedDateStart: '入账日期起',
    accountedDateEnd: '入账日期止',
    journalVoucherNum: '凭证编号',
    reverseDate: '冲销入账日期',
    reverseVoucherNum: '冲销凭证编号',
    invoiceDetailCode: '行号',
    invoiceDepartmentCode: '部门',
    contractNo: '合同号',
    ladingNo: '提单号',
    outboundNo: '业务单据号',
    ladingNoReturn: '提单号/退换货单号',
    ladingDetailNo: '提单行项目号',
    ladingDetailNoReturn: '提单/退换货单行项目号',
    productNo: '商品编号',
    productDesc: '商品描述',
    ladingQuantity: '提单数量',
    invoicedQuantity: '已开票数量',
    contractUnitPrice: '合同单价',
    invoiceQuantity: '本次开票数量',
    invoiceUnit: '单位',
    invoiceUnitPrice: '含税单价',
    taxRate: '税率',
    ladingAmount: '提单金额',
    invoicedAmount: '已开票金额',
    exchangeRate: '汇率',
    recoverableTaxRate: '出口退税率',
    reverseFlag: '冲销标识',
    companyCurrencyTip: '请维护所选公司分类账本位币',
    exchangeRateTip: '缺少对应日期汇率，请维护',
    deleteTip: '只有已保存、已撤回、已退回状态可删除',
    submitTip: '只有已保存、已撤回、已退回状态可提交',
    generateVoucherTip: '只有已提交状态并且未入账或者入账失败的可生成凭证',
    withdrawTip: '只有已提交状态并且未入账或者入账失败的可撤回',
    overAmount: '开票金额超过提单金额，请修改',
    noListTip: '请添加行项目信息',
    projectInitiationNo: '项目编号',
    receivableSettlementNo: '应收结算单号',
    issueType: '开票状态',
    expenseTypeCode: '费用类型',
    taxRateCode: '税收分类',
  },
};
